/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Levne_BydleniInputs */

const cs_enum_levne_bydleni = /** @type {(inputs: Enum_Levne_BydleniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levné bydlení`)
};

const en_enum_levne_bydleni = /** @type {(inputs: Enum_Levne_BydleniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levné bydlení`)
};

/**
* | output |
* | --- |
* | "Levné bydlení" |
*
* @param {Enum_Levne_BydleniInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_levne_bydleni = /** @type {((inputs?: Enum_Levne_BydleniInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Levne_BydleniInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_levne_bydleni(inputs)
	return cs_enum_levne_bydleni(inputs)
});